import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from '../../services/authorize.service';
import { CreateUserInput } from '../../models/CreateUserInput.model';
import { FormControl, FormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { InputComponent } from '../../components/input/input.component';
import { PasswordValidationComponent } from '../../components/password-validation/password-validation.component';
import { setContainerTypeAction, showLoadingMaskAction } from '../../ngrx/actions/global.actions';
import { AlertService } from '../../services/alert.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, InputComponent]
})
export class RegisterComponent extends PasswordValidationComponent implements OnInit {

  registerForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, this.passwordValidation.bind(this)]),
    confirmPassword: new FormControl('', [Validators.required, this.passwordMatchValidation.bind(this)])
  });

  constructor(
    private authService: AuthorizeService,
    private router: Router,
    private alertService: AlertService) {
    super();
  }

  ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
  }

  passwordMatchValidation(passwordMatchControl: FormControl): ValidationErrors | null {
    if (passwordMatchControl.value === this.registerForm?.get('password')?.value) {
      return null;
    } else {
      return { passwordMatch: "Passwords do not match!" };
    }
  }

  onFormValueChange(controlName: string, value: any) {
    let control = this.registerForm.get(controlName);
    if (control) {
      control.setValue(value, { emitEvent: true });
      control.updateValueAndValidity();
      this.registerForm.updateValueAndValidity();
    }
  }

  onSubmit() {
    this.dispatch(showLoadingMaskAction({ showLoadingMask: true }));
    if (!this.registerForm.valid) {
      for (let control in this.registerForm.controls) {
        if (!this.registerForm.get(control)?.valid) {
          this.registerForm.get(control)?.markAsDirty();
          this.alertService.showSnackBar(`Error with ${control} input`);
          this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
          return;
        }
      }
    }
    let newUser: CreateUserInput = {
      UserName: this.registerForm.get("email")?.value,
      Email: this.registerForm.get("email")?.value,
      IsActive: true,
      EmailConfirmed: true,
      FirstName: this.registerForm.get("firstName")?.value,
      LastName: this.registerForm.get("lastName")?.value,
      Password: this.registerForm.get("password")?.value
    };
    this.subs.push(this.authService.createUser(newUser).subscribe((result) => {
        this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
        this.alertService.showSnackBar("User created successfully!");
        this.router.navigate(['/authentication/registration-landing']);
    })); 
  }
}
